import { PersonState } from './IPerson'

export const initialState: PersonState = {
  current: undefined,
  list: undefined,
  hours: undefined,
  absences: undefined,
}
